import { useLocation } from 'react-router';

export const useEmbed = () => {
  const queryParam = new URLSearchParams(useLocation().search);
  return queryParam.get('embed');
};

export const usePreview = () => {
  const queryParam = new URLSearchParams(useLocation().search);
  return queryParam.get('preview');
};

// export const useGetPaymentParam = () => {
//   const queryParam = new URLSearchParams(useLocation().search);
//   return queryParam.get('payment');
// };
